module.exports = __webpack_public_path__ + "img/1.1e8f21f4.png";